import {
  ConcretePropertyName,
  ConcreteQuality,
  ConcreteType,
} from './concrete.model';
import {
  ElementPropertyType,
  IFactoryProperty,
} from '@shared/models/element-property.model';
import { IConditionalNode } from '@shared/helpers/conditional-nodes.helpers';

const castInPlaceNodes: IConditionalNode<IFactoryProperty> = {
  conditions: {
    [ConcretePropertyName.Type]: [ConcreteType.CastInPlace],
  },
  nodes: [
    {
      name: ConcretePropertyName.Quality,
      type: ElementPropertyType.Select,
      options: Object.values(ConcreteQuality),
      indentation: 1,
    },
    {
      name: ConcretePropertyName.ReinforcementSteel,
      type: ElementPropertyType.Expression,
      unit: 'kg/m³',
      count: 0,
      min: 0,
      indentation: 1,
    },
    {
      name: ConcretePropertyName.StainlessReinforcement,
      type: ElementPropertyType.Switch,
      indentation: 1,
    },
  ],
};

export const concreteProperties: IConditionalNode<IFactoryProperty>[] = [
  {
    name: ConcretePropertyName.Type,
    type: ElementPropertyType.Select,
    options: [
      ConcreteType.CastInPlace,
      ConcreteType.BalconyAndStairs,
      ConcreteType.BalconyAccessSlab,
      ConcreteType.BeamsPrestressed,
      ConcreteType.BeamsSlackReinforced,
      ConcreteType.FloorPlatesForFloorSystems,
      ConcreteType.HollowCoreFloors,
      ConcreteType.SolidFloorStructure,
      ConcreteType.TTConcreteSlabs,
      ConcreteType.Columns,
      ConcreteType.ExternalWallPanels,
      ConcreteType.HalfSandwichWallPanel,
      ConcreteType.SandwichWallPanels,
      ConcreteType.SolidInteriorWallPanel,
      ConcreteType.ThinShellPrecastPanels,
      ConcreteType.Other,
    ],
  },
  castInPlaceNodes,
];
